var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "0 0 9600 4800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v6H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.5h8V4zm6 0H3v4h-5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(800)",
    strokeWidth: 0.6,
    fill: "#012169",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m0 0 6 3M0 3l6-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 0.4,
    clipPath: "url(#b)",
    d: "m0 0 6 3M0 3l6-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M3 0v4M0 1.5h7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    d: "M3 0v4M0 1.5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3h6V0h6v6H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7200 2400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    fill: "#fff",
    d: "m0-1992 81 249h261l-211 153 81 249L0-1494l-212 153 81-249-211-153h261z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(24)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(48)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(216)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(288)",
    xlinkHref: "#d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.c00540ea65ff35eef2e3fe01528854c2.svg";
export { ForwardRef as ReactComponent };